import React, { useState } from 'react';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Button from '@material-ui/core/Button';

// import UserSelection from './UserSelections'; // Removed
import CohortSelection from './CohortSelection';
import { bulkAddEmailToAlmax } from '../../../../services/apiService';
import { toast } from 'react-toastify';
import LoadingCircleIcon from '../../../../icons/LoadingCircle';

function BulkAdd({ dialogOpen, setDialogOpen, dataFetch }) {
  // Bulk email input state
  const [emailInput, setEmailInput] = useState('');
  const [parsedEmails, setParsedEmails] = useState([]); // {email, valid}
  const [almaxCohort, setAlmaxCohort] = useState(null);
  const [activeStep, setActiveStep] = React.useState(0);
  const [loading, setLoading] = useState(false);

  const steps = ['Add Emails', 'Select Cohort'];

  // Email validation regex
const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const parseEmails = (input) => {
  const raw = input
    .split(/\n|,|;/)
    .map((e) =>
      e
        .trim()                       // remove spaces around
        .replace(/\r/g, "")           // remove carriage returns
        .replace(/\u00A0/g, " ")      // replace non-breaking spaces
        .replace(/[^\S\r\n]+/g, "")   // collapse stray whitespace
    )
    .filter(Boolean);

  // Remove duplicates
  const unique = Array.from(new Set(raw));

  // Validate
  return unique.map((email) => ({
    email,
    valid: emailRegex.test(email),
  }));
};


  // Update parsed emails on input change
  React.useEffect(() => {
    setParsedEmails(parseEmails(emailInput));
  }, [emailInput]);

  const validEmails = parsedEmails.filter((e) => e.valid).map((e) => e.email);
  // const invalidEmails = parsedEmails.filter(e => !e.valid).map(e => e.email);

  const bulkAddHandler = async () => {
    try {
      setLoading(true);
      const response = await bulkAddEmailToAlmax({
        userEmails: validEmails, // or emails, depending on your logic
        almaXCohort: {
          almaxCohortId: almaxCohort.id,
          almaxCohortName: almaxCohort.name,
        },
      });
      console.log(response, 'respns');

      if (response.success) {
        if (response.updatedUsers && response.updatedUsers.length > 0) {
          toast.success(
            `Successfully added ${response.updatedUsers.length} users!`
          );
        }
        if (response.errors && response.errors.length > 0) {
          response.errors.forEach((err) => {
            toast.error(`Failed: ${err.email} - ${err.message}`);
          });
        }
      } else {
        toast.error('Bulk add failed. Please try again.');
      }
      toggleDialog();
      // dataFetch(); // Uncomment if you want to refresh data
    } catch (err) {
      toast.error('An error occurred while adding users.');
    } finally {
      setLoading(false);
    }
  };

  const toggleDialog = () => {
    setDialogOpen(false);
    setActiveStep(0);
    setEmailInput('');
    setParsedEmails([]);
    setAlmaxCohort(null);
  };

  return (
    <Dialog
      aria-labelledby='almax-dialog-title'
      open={dialogOpen}
      onClose={toggleDialog}
      maxWidth='sm'
      fullWidth
    >
      <DialogTitle id='almax-dialog-title'>
        Bulk Add Users To AlmaX Cohort
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Paste or type emails to add to AlmaX
        </DialogContentText>
        <Stepper activeStep={activeStep} alternativeLabel>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
        {activeStep === 0 && (
          <div style={{ marginTop: 24 }}>
            <textarea
              value={emailInput}
              onChange={(e) => setEmailInput(e.target.value)}
              rows={6}
              style={{
                width: '100%',
                fontFamily: 'monospace',
                fontSize: 14,
                padding: 8,
                borderRadius: 4,
                border: '1px solid #ccc',
                resize: 'vertical',
              }}
              placeholder='Enter emails separated by newlines or commas'
              autoFocus
            />
            {/* {invalidEmails.length > 0 && (
              <div style={{ color: 'red', fontSize: 13, marginTop: 4 }}>
                Invalid emails: {invalidEmails.slice(0, 3).join(', ')}{invalidEmails.length > 3 ? '...' : ''}
              </div>
            )} */}
          </div>
        )}
        {activeStep === 1 && (
          <CohortSelection value={almaxCohort} setValue={setAlmaxCohort} />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={toggleDialog} color='primary'>
          Cancel
        </Button>
        {activeStep === 0 ? (
          <Button
            color='primary'
            disabled={validEmails.length === 0}
            onClick={() => setActiveStep(1)}
          >
            Next
          </Button>
        ) : loading ? (
          <LoadingCircleIcon iconStyle='w-4 h-4 mr-2' />
        ) : (
          <Button
            color='primary'
            onClick={bulkAddHandler}
            disabled={validEmails.length === 0 || !almaxCohort}
          >
            Add
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}

export default BulkAdd;
